import config from 'Cloud/config';
import { pdfjs } from 'react-pdf';

const pathToWorker = `${config.get('BUILD_URLS').js}/pdf.worker.min.js`;

pdfjs.GlobalWorkerOptions.workerSrc = pathToWorker;
